/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { UpdateCourseActivityOrderOptions, UpdateCourseActivityOrderStatus200, UpdateCourseActivityOrderStatus422 } from '../models/UpdateCourseActivityOrder'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateCourseActivityOrder } from '../clients/axios/updateCourseActivityOrder'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateCourseActivityOrderMutationKey = () => [{ url: '/admin/course/activity/:activity_id/set-order/:index' }] as const

export function updateCourseActivityOrderMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = updateCourseActivityOrderMutationKey()
  return mutationOptions<UpdateCourseActivityOrderStatus200, ResponseErrorConfig<UpdateCourseActivityOrderStatus422>, UpdateCourseActivityOrderOptions, TContext>({
    mutationKey,
    mutationFn: async({ path }) => {
      return await updateCourseActivityOrder({ ...config, path, throwOnError: true })
    },
  })
}

/**
 * @summary Update Course Activity Order
 * {@link /admin/course/activity/:activity_id/set-order/:index}
 */
export function useUpdateCourseActivityOrder<TContext>(options: {
  mutation?: UseMutationOptions<UpdateCourseActivityOrderStatus200, ResponseErrorConfig<UpdateCourseActivityOrderStatus422>, UpdateCourseActivityOrderOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? updateCourseActivityOrderMutationKey()

  const baseOptions = updateCourseActivityOrderMutationOptions(config) as UseMutationOptions<UpdateCourseActivityOrderStatus200, ResponseErrorConfig<UpdateCourseActivityOrderStatus422>, UpdateCourseActivityOrderOptions, TContext>

  return useMutation<UpdateCourseActivityOrderStatus200, ResponseErrorConfig<UpdateCourseActivityOrderStatus422>, UpdateCourseActivityOrderOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<UpdateCourseActivityOrderStatus200, ResponseErrorConfig<UpdateCourseActivityOrderStatus422>, UpdateCourseActivityOrderOptions, TContext>
}
